var moduleMap = {
	"./FreightApp": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_mui_x-date-pickers_AdapterDateFns_AdapterDateFns_js-node_modules_sentry_-473d4e"), __webpack_require__.e("src_federation_federated-app_tsx-webpack_sharing_consume_default_react-dom_react-dom")]).then(() => (() => ((__webpack_require__(/*! ./src/federation/federated-app */ "./src/federation/federated-app.tsx")))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});